import React from 'react'
import { Box, Stack, Typography, Paper } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import LoginButton from '../../pages/Auth/Login/components/LoginButton'

interface ErrorFallbackProps {
  error: Error
  resetError: () => void
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetError }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleBackToDashboard = () => {
    resetError()
    navigate('/dashboard')
  }

  const isDevelopment = process.env.NODE_ENV === 'development'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        padding: 3
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        spacing={3}
        sx={{
          maxWidth: 400,
          textAlign: 'center'
        }}
      >
        <i 
          className="fa-regular fa-lightbulb-exclamation-on"
          style={{
            fontSize: '160px',
            color: theme.palette.grey[300]
          }}
        />
        
        <Typography
          variant="h5"
          sx={{
            fontSize: 20,
            fontWeight: 600,
            color: theme.palette.text.primary
          }}
        >
          {t('error.occurred')}
        </Typography>

        {isDevelopment && (
          <Paper 
            sx={{ 
              p: 2, 
              width: '100%',
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              textAlign: 'left'
            }}
          >
            <Typography variant="subtitle2" fontWeight={600} color="error" gutterBottom>
              Error Details (Development Mode):
            </Typography>
            <Typography 
              variant="body2" 
              component="pre" 
              sx={{ 
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: 11,
                fontFamily: 'monospace',
                maxHeight: 200,
                overflowY: 'auto'
              }}
            >
              {error.message}
            </Typography>
          </Paper>
        )}

        <LoginButton
          onClick={handleBackToDashboard}
          sx={{
            minWidth: 200
          }}
        >
          {t('error.backToDashboard')}
        </LoginButton>
      </Stack>
    </Box>
  )
}

export default ErrorFallback